import * as React from 'react';
import { Button, Trash16 } from '@cian/ui-kit';
import { IRemoveFavoriteParameters } from '../../actions/favoriteEntities';
import { IRemoveFavorite } from '../../types/results';
import { EEntityType, EDealType } from '../../types/filters';
import * as styles from './RemoveFavorite.css';

export interface IRemoveFavoriteStoreProps {
  removeFavoriteState: IRemoveFavorite;
}

export interface IRemoveFavoriteDispatchProps {
  onClick(parameters: IRemoveFavoriteParameters): void;
}

export interface IRemoveFavoriteOwnProps {
  dealType: EDealType;
  entityId: number;
  favoriteEntityType: EEntityType;
}

export type TRemoveFavoriteProps = IRemoveFavoriteStoreProps & IRemoveFavoriteDispatchProps & IRemoveFavoriteOwnProps;

export function RemoveFavorite({
  removeFavoriteState: { entityIds },
  onClick,
  entityId,
  favoriteEntityType,
  dealType,
}: TRemoveFavoriteProps) {
  return (
    <div className={styles['container']}>
      <Button
        size="XS"
        theme="fill_secondary"
        beforeIcon={<Trash16 color="primary_100" />}
        loading={Boolean(entityIds && entityIds.includes(entityId))}
        onClick={() => onClick({ dealType, entityId, favoriteEntityType })}
        title="Удалить из избранного"
      />
    </div>
  );
}
